import React from "react";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import foto1 from "../immaginiDino/galleryIMG/foto1.png";
import foto2 from "../immaginiDino/galleryIMG/foto2.jpeg";
import foto3 from "../immaginiDino/galleryIMG/foto3.jpeg";
import foto4 from "../immaginiDino/galleryIMG/foto4.jpeg";
import foto5 from "../immaginiDino/galleryIMG/foto5.jpeg";
import foto6 from "../immaginiDino/galleryIMG/foto6.jpeg";
import foto7 from "../immaginiDino/galleryIMG/foto7.jpeg";
import foto8 from "../immaginiDino/carougalleryIMGsel/foto8.jpeg";

function Gallery() {
  return (
    <>
      <div className="container mx-auto px-5 py-2 lg:px-32 lg:pt-24">
        <div className="-m-1 flex flex-wrap md:-m-2">
          <div className="flex w-1/2 flex-wrap">
            <div className="w-1/2 p-1 md:p-2">
              <div className="aspect-square overflow-hidden">
                <img
                  alt="Gallery scene 1"
                  className="block h-full w-full object-cover"
                  src={foto1}
                />
              </div>
            </div>
            <div className="w-1/2 p-1 md:p-2">
              <div className="aspect-square overflow-hidden">
                <img
                  alt="Gallery scene 2"
                  className="block h-full w-full object-cover"
                  src={foto2}
                />
              </div>
            </div>
            <div className="w-full p-1 md:p-2">
              <div className="aspect-square overflow-hidden">
                <img
                  alt="Gallery scene 3"
                  className="block h-full w-full object-cover"
                  src={foto3}
                />
              </div>
            </div>
          </div>
          <div className="flex w-1/2 flex-wrap">
            <div className="w-full p-1 md:p-2">
              <div className="aspect-square overflow-hidden">
                <img
                  alt="Gallery scene 4"
                  className="block h-full w-full object-cover"
                  src={foto4}
                />
              </div>
            </div>
            <div className="w-1/2 p-1 md:p-2">
              <div className="aspect-square overflow-hidden">
                <img
                  alt="Gallery scene 5"
                  className="block h-full w-full object-cover"
                  src={foto5}
                />
              </div>
            </div>
            <div className="w-1/2 p-1 md:p-2">
              <div className="aspect-square overflow-hidden">
                <img
                  alt="Gallery scene 6"
                  className="block h-full w-full object-cover"
                  src={foto6}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Gallery;
